<template>
  <div class="flex flex-col justify-center mt-2">
    <div>
      {{ description }}
    </div>
    <div class="mt-2">
      <MButton
        class="button-success"
        :style="{ background: 'var(--success-button-bg)' }"
        @click="$emit('transfer')"
      >
        <MIcon name="check" /> {{ btnText }}
      </MButton>
      <MButton
        class="ml-2 button-error"
        :style="{ background: 'var(--error-button-bg)' }"
        @click="$emit('reject')"
      >
        <MIcon name="check" /> {{ rejectBtnText }}
      </MButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatNotification',
  props: {
    transferRequest: { type: Object, required: true },
    description: { type: String, required: true },
    btnText: { type: String, required: true },
    rejectBtnText: { type: String, required: true },
  },
}
</script>
